import React from 'react';
import { Tooltip } from 'antd';
import styles from './avatar.module.scss';
import AvatarTag from '../Avatar/avatarTag';
export const SimpleAvatar = (props) => {
    const { user, onClick, showRedDot = false, isSwitching } = props;
    const { email, isMobileBindAccount } = user;
    return (React.createElement(Tooltip, { title: email || '', key: email, trigger: ['hover'], placement: "right" },
        React.createElement("div", { className: styles.avatarWrapper, onClick: onClick },
            isSwitching && (React.createElement("div", { className: styles.avatarLoadingWrap },
                ' ',
                React.createElement("div", { className: styles.avatarLoading }),
                ' ')),
            React.createElement(AvatarTag, { size: 32, user: user }),
            isMobileBindAccount && React.createElement("div", { className: styles.avatarLink }),
            showRedDot && React.createElement("div", { className: styles.avatarRedDot }))));
};
